import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { CustomPlanRedirect } from "./CustomPlanRedirect";

const ContractTemplatesPage = lazy(() => import("@/pages/contract-templates/ContractTemplatesPage"));
const ContractTemplateEditPage = lazy(() => import("@/pages/contract-templates/ContractTemplateEditPage"));
const ClauseLibraryPage = lazy(() => import("@/pages/clause-library/ClauseLibraryPage"));

export function ContractDocumentRoutes() {
  return (
    <>
      <Route path="/contract-templates" element={<ProtectedRoute><CustomPlanRedirect><ContractTemplatesPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contract-templates/new" element={<ProtectedRoute><CustomPlanRedirect><ContractTemplateEditPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/contract-templates/:id" element={<ProtectedRoute><CustomPlanRedirect><ContractTemplateEditPage /></CustomPlanRedirect></ProtectedRoute>} />
      <Route path="/clause-library" element={<ProtectedRoute><CustomPlanRedirect><ClauseLibraryPage /></CustomPlanRedirect></ProtectedRoute>} />
    </>
  );
}
